<span class="header">
  Mould log
  <button
    *emVisibleForRoles="['Mould Engineering']"
    nz-button
    nzType="primary"
    (click)="openModal($event)"
  >
    Mould log overview
  </button>
</span>
